<template>
  <div class="home" style="height:100%;overflow: auto;">
    <el-backtop target=".home"></el-backtop>
    <Header/>
    <Banner/>
<!--    <Notice />-->
<!--    <Todo v-if="isLOgin"/>-->
    <div v-for="(item, i) in subList" :key="item.id">
      <Special :title="item.cateName" :children="item.courseList" />
    </div>
    <Buy v-if="isLOgin"/>
<!--    <div v-for="(item, i) in subList" :key="item.id">-->
<!--      <Special :title="item.cateName" :children="item.children" />-->
<!--    </div>-->

<!--    <RankList/>-->
    <!-- 通知公告 -->
    <Footer/>
  </div>
</template>

<script>
import Header from "./header/index";
import Banner from "./banner/index";
import Learning from "./learningCenter/index";
// import Graphical from "./graphical/index";
import Notice from "./notice/index"
import Todo from "./todo/index";
import Buy from "./buy/index";

// import Recommend from "./informationRecommend/index";
// import Subject from "./subjectRecommend/index";
import Special from "./specialSubject/index";
// import WebB from "./webBottom/index";
import Footer from "./footer";
import RankList from "./rankList"
import {getCategory} from '@/api/home'
import { getToken } from '@/utils/auth'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home",
  // eslint-disable-next-line vue/no-unused-components
  components: {
    Header,
    Banner,
    Learning,
    // Graphical,
    Todo,
    Buy,
    // Recommend,
    // Subject,
    Special,
    // WebB,
    Footer,
    RankList,
    Notice
  },
  data() {
    return {
      subList:[],
      userinfo: {},
    };
  },
  created() {
    // const res = this.getLocal()
    // this.dialogVisible = !res;
    this.getCategoryList()
  },
  computed: {
    isLOgin: function() {
      return getToken()
    },
  },
  methods: {
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let res = this.account.filter(
              (item) =>
                  this.form.username === item.username &&
                  this.form.password === item.password
          );
          this.dialogVisible = res.length === 0;
          if (this.dialogVisible) {
            this.$message({
              type: "error",
              message: "用户名或密码不正确！",
            });
          } else {
            this.setLocal(res[0]);
          }
        } else {
          return false;
        }
      });
    },
    getLocal() {
      return localStorage.getItem("userinfo");
    },
    setLocal(val) {
      localStorage.setItem("userinfo", JSON.stringify(val));
    },
    // 获取分类
    async getCategoryList(){
      try {
        const res = await getCategory()
        this.subList = res.data
      } catch (error) {
        console.log(error);
      }
    }
  },
};
</script>
<style scoped lang="scss">
.home {
  height: 100%;
  // padding-bottom: 50px;
  position: relative;
  overflow-y: auto;

  .login-form {
    width: 100%;
    height: 100%;
  }
}

</style>
